// import React, { useState } from "react";
// import "./Services.css";
// import {
//   CodeOutlined,
//   LaptopOutlined,
//   MobileOutlined,
//   RobotOutlined,
//   CloudOutlined,
//   ApiOutlined,
//   GlobalOutlined,
//   BookOutlined,
//   DownOutlined,
//   UpOutlined,
// } from "@ant-design/icons";

// const services = [
//   {
//     id: 1,
//     icon: <CodeOutlined />,
//     title: "Software Development",
//     desc: "We build custom enterprise software solutions engineered for scalability and security. Our expert team transforms complex business workflows into intuitive digital applications that streamline operations and boost productivity.",
//     tag: "Enterprise",
//   },
//   {
//     id: 2,
//     icon: <LaptopOutlined />,
//     title: "Web Development",
//     desc: "Create a powerful online presence with responsive websites built using Next.js and React. We deliver lightning-fast performance, pixel-perfect designs, and SEO-optimized architecture to convert visitors into loyal customers.",
//     tag: "Popular",
//   },
//   {
//     id: 3,
//     icon: <MobileOutlined />,
//     title: "App Development",
//     desc: "Launch feature-rich native and cross-platform mobile applications for iOS and Android. Built with Flutter and React Native, our apps deliver exceptional user experiences, smooth animations, and seamless deployment.",
//     tag: "Trending",
//   },
//   {
//     id: 4,
//     icon: <RobotOutlined />,
//     title: "AI Solutions",
//     desc: "Empower your business with intelligent AI chatbots, predictive analytics, and machine learning models. We integrate NLP and computer vision to automate operations, reduce costs, and unlock data-driven insights.",
//     tag: "New",
//   },
//   {
//     id: 5,
//     icon: <CloudOutlined />,
//     title: "Cloud & DevOps",
//     desc: "Transform your infrastructure with modern cloud solutions and automated CI/CD pipelines. Using AWS, Docker, and Kubernetes, we ensure high availability, zero-downtime, and optimized cloud cost management.",
//     tag: "Pro",
//   },
//   {
//     id: 6,
//     icon: <ApiOutlined />,
//     title: "API Integration",
//     desc: "Connect your digital ecosystem seamlessly with enterprise-grade third-party API integrations. We build secure pipelines linking payment gateways, ERP, and CRM platforms with real-time data synchronization.",
//     tag: "Reliable",
//   },
//   {
//     id: 7,
//     icon: <GlobalOutlined />,
//     title: "Digital Marketing",
//     desc: "Accelerate your brand growth with data-driven SEO strategies and targeted social media campaigns. Our marketing experts craft compelling brand stories designed to maximize ROI and generate consistent leads.",
//     tag: "Growth",
//   },
//   {
//     id: 8,
//     icon: <BookOutlined />,
//     title: "Training & Internship",
//     desc: "Kickstart your tech career with our structured training and internship programs. Get hands-on experience with live commercial projects, expert mentorship, and dedicated placement assistance in top-tier companies.",
//     tag: "Career",
//   },
// ];

// export default function Services() {
//   const [showAll, setShowAll] = useState(false);
//   const visible = showAll ? services : services.slice(0, 4);

//   return (
//     <section className="services-light">
//       <div className="service-bg-light"></div>
//       <div className="service-glow-1"></div>
//       <div className="service-glow-2"></div>

//       <div className="container-light">
//         <div className="section-title-light">
//           <span className="badge-light">
//             <span className="badge-dot"></span>
//             OUR SERVICES
//           </span>
         
//           <p>
//             We deliver innovative software, AI, cloud, and digital solutions
//             that empower businesses to grow faster with cutting-edge technology
//             and expert craftsmanship.
//           </p>
//         </div>

//         <div className="services-grid-light">
//           {visible.map((item) => (
//             <div className="service-card-light" key={item.id}>
//               <div className="card-tag">{item.tag}</div>

//               <div className="service-top-light">
//                 <div className="service-icon-light">{item.icon}</div>
//                 <span className="service-number-light">0{item.id}</span>
//               </div>

//               <h3>{item.title}</h3>
//               <p className="service-desc-justify">{item.desc}</p>
//             </div>
//           ))}
//         </div>

//         <div className="view-more-light">
//           <button onClick={() => setShowAll(!showAll)}>
//             {showAll ? (
//               <>
//                 View Less <UpOutlined />
//               </>
//             ) : (
//               <>
//                 Explore All Services <DownOutlined />
//               </>
//             )}
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

import React, { useState } from "react";
import "./Services.css";
import {
  CodeOutlined,
  LaptopOutlined,
  MobileOutlined,
  RobotOutlined,
  CloudOutlined,
  ApiOutlined,
  GlobalOutlined,
  BookOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";

const services = [
  {
    id: 1,
    icon: <CodeOutlined />,
    title: "Software Development",
    desc: "We build custom enterprise software solutions engineered for scalability and security. Our expert team transforms complex business workflows into intuitive digital applications that streamline operations and boost productivity.",
    tag: "Enterprise",
  },
  {
    id: 2,
    icon: <LaptopOutlined />,
    title: "Web Development",
    desc: "Create a powerful online presence with responsive websites built using Next.js and React. We deliver lightning-fast performance, pixel-perfect designs, and SEO-optimized architecture to convert visitors into loyal customers.",
    tag: "Popular",
  },
  {
    id: 3,
    icon: <MobileOutlined />,
    title: "App Development",
    desc: "Launch feature-rich native and cross-platform mobile applications for iOS and Android. Built with Flutter and React Native, our apps deliver exceptional user experiences, smooth animations, and seamless deployment.",
    tag: "Trending",
  },
  {
    id: 4,
    icon: <RobotOutlined />,
    title: "AI Solutions",
    desc: "Empower your business with intelligent AI chatbots, predictive analytics, and machine learning models. We integrate NLP and computer vision to automate operations, reduce costs, and unlock data-driven insights.",
    tag: "New",
  },
  {
    id: 5,
    icon: <CloudOutlined />,
    title: "Cloud & DevOps",
    desc: "Transform your infrastructure with modern cloud solutions and automated CI/CD pipelines. Using AWS, Docker, and Kubernetes, we ensure high availability, zero-downtime, and optimized cloud cost management.",
    tag: "Pro",
  },
  {
    id: 6,
    icon: <ApiOutlined />,
    title: "API Integration",
    desc: "Connect your digital ecosystem seamlessly with enterprise-grade third-party API integrations. We build secure pipelines linking payment gateways, ERP, and CRM platforms with real-time data synchronization.",
    tag: "Reliable",
  },
  {
    id: 7,
    icon: <GlobalOutlined />,
    title: "Digital Marketing",
    desc: "Accelerate your brand growth with data-driven SEO strategies and targeted social media campaigns. Our marketing experts craft compelling brand stories designed to maximize ROI and generate consistent leads.",
    tag: "Growth",
  },
  {
    id: 8,
    icon: <BookOutlined />,
    title: "Training & Internship",
    desc: "Kickstart your tech career with our structured training and internship programs. Get hands-on experience with live commercial projects, expert mentorship, and dedicated placement assistance in top-tier companies.",
    tag: "Career",
  },
];

export default function Services() {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? services : services.slice(0, 4);

  return (
    <section className="services-light">
      <div className="service-bg-light"></div>
      <div className="service-glow-1"></div>
      <div className="service-glow-2"></div>

      <div className="container-light">
        <div className="section-title-light">
          <span className="badge-light">
            <span className="badge-dot"></span>
            OUR SERVICES
          </span>
         
          <p>
            We deliver innovative software, AI, cloud, and digital solutions
            that empower businesses to grow faster with cutting-edge technology
            and expert craftsmanship.
          </p>
        </div>

        <div className="services-grid-light">
          {visible.map((item) => (
            <div className="service-card-light" key={item.id}>
              <div className="card-tag">{item.tag}</div>

              {/* 👇 Icon aur Heading ab ek hi row me hain */}
              <div className="service-header-row">
                <div className="service-icon-light">{item.icon}</div>
                <h3>{item.title}</h3>
              </div>

              <p className="service-desc-justify">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="view-more-light">
          <button onClick={() => setShowAll(!showAll)}>
            {showAll ? (
              <>
                View Less <UpOutlined />
              </>
            ) : (
              <>
                Explore All Services <DownOutlined />
              </>
            )}
          </button>
        </div>
      </div>
    </section>
  );
}